<template>
  <div class="matchPage">
    <div style="width:100%;">
        <!-- 顶部tabs -->
        <div style="width:100%; background:#fff; border-bottom:1px solid #dfdfdf; position: fixed; top: 0; z-index:2;">
            <div class="header">
                <div class="left" style="cursor:pointer;" @click="clickLogoImg">
                    <img src="@/assets/img/logo.png" alt="">
                </div>
                <div class="right">
                    <div class="rightItem"   v-for="(item, index) in headerArr" :key="index" @click="clickHeaderItem(index)">{{item.name}}</div>
                </div>
            </div>
        </div>
        <!-- banner -->
        <div class="banner">
            <img src="@/assets/img/banner2.png" alt="">
        </div>


        <!-- 作品提交 -->
        <!-- <div v-show="phoneTestShow"  class="phoneTestContainer">
           <phone-test ref="phoneTest" ></phone-test>
        </div> -->
        <!-- 除作品提交 -->
        <!-- <div v-show="!phoneTestShow"> -->
            <!-- 大赛介绍 -->
            <div class="brief">
                <div class="titlePart">
                    <div class="titleText">大赛介绍</div>
                    <div class="titleLine">
                        <img  src="@/assets/img/titleLine.png" alt="">
                    </div>
                </div>
                <div class="briefContent">
                <div class="left">
                    <div class="firstPart0">
                        作为全新一代开源精简指令集，RISC-V在嵌入式领域备受关注，沁恒微电子基于自研RISC-V架构青稞微处理器，推出高性能、无线型、低功耗等多个系列的RISC-V MCU产品。采用RISC-V架构的MCU已获得越来越多工程师的青睐，并应用到实际产品开发中，RISC-V生态正逐渐起步。
                    </div>
                    <div class="firstPart1">
                        “RISC-V MCU创新应用大赛”以嵌入式应用为导向，以培养RISC-V MCU产业人才为目标，打造RISC-V MCU创新应用平台，助力RISC-V在国内更好的扎根落地，并在应用中快速发展壮大。
                    </div>
                    <div class="firstPart2">
                        首届“RISC-V MCU创新应用大赛”，共有500多名工程师报名参赛，收获了众多基于通用增强型CH32V103、低功耗蓝牙CH573等RISC-V MCU的创意作品。为了进一步培养RISC-V产业人才，助力RISC-V生态建设，现开启第二届“RISC-V MCU 创新应用大赛”。本次大赛推荐基于互联型CH32V307、无线型 CH32V208两款RISC-V MCU进行创意开发。
                    </div>
                    <div class="secondPart">
                        <div class="sponsor" v-for="(item,index) in sponsorArr" :key="index">
                            <div class="sponsorName">{{item.name}}</div>
                            <div class="sponsorTip">{{item.tip}}</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="right">
                    <div class="qrCode">
                        <img src="@/assets/img/qrCode.png" alt="">
                    </div>
                    <div class="codeTip" style="font-size:18px; color:#999; line-height:32px;">亦可扫码参与报名</div>
                    <div class="codeBtn" style="cursor:pointer;" @click="clickSignUp"> <img  src="@/assets/img/qrBtn.png" alt=""> </div>
                </div> -->
                </div>
            </div>
            <!-- 大赛奖项 -->
            <div class="prize">
                <div class="titlePart">
                    <div class="titleText">大赛奖项</div>
                    <div class="titleLine">
                        <img src="@/assets/img/titleLine.png" alt="">
                    </div>
                </div>
                <div class="prizeContent">
                    <div class="prizeItem" v-for="(item,index) in prizeArr" :key="index">
                        <img :src="item.src" alt="">
                        <div class="name">{{item.name}} <span class="people">（{{item.people}}）</span> </div>
                        <div class="money">{{item.money}}</div>
                        <div class="certificate">{{item.certificate}}</div>
                    </div>
                </div >
                <div class='prizeItem2'>
                    <div class="left">
                        <img src="@/assets/img/seed.png" alt="">
                    </div>
                    <div class="right">
                        <div class="name">种子资金:  <span class="people">助力优秀作品市场化</span> </div>
                        <div class="money">￥50000元现金</div>
                        <div class="certificate">（单独评选，根据提交作品评估资助数量和金额）</div>
                    </div>
                </div>
                <!-- <div class="prizeTips">
                    大赛对于成功批量商用的作品，以及特别优秀的作品博文、视频等有额外的奖励
                </div> -->
            </div>
            <!-- 开发平台 -->
            <div class="platform">
                <div class="platformTitle">
                    <div class="titleText">大赛RISC-V MCU开发平台</div>
                    <div class="titleLine">
                        <img src="@/assets/img/whiteLine.png" alt="">
                    </div>
                </div>
                <div class="platformContent">
                <div class="platformItem" v-for="(item,index) in platformArr" :key="index">
                    <div class="left">
                        <img :class="'platformImg_'+index" :src="item.src" alt="">
                    </div>
                    <div class="right">
                        <div class="rightTitle">{{item.name}}</div>
                        <div class="tip" v-for="(t,i) in item.handbook" :key="i">
                            <div style="display:flex;"> <img style="margin-right:20px; width:19px; height:19px; padding-top: 7px;" src="@/assets/img/tipIcon.png" alt=""> <span style="line-height:35px">{{t.n}}：</span> </div>
                            <div @click="clickLink(t.link)" style="line-height:35px; text-align:left; padding-left: 42px; cursor:pointer;">{{t.link}}</div>
                        </div>
                    </div>
                </div>
                <div class="platformItem">
                    <div >
                        <div class="deve_left1">
                            <img style="width:520px;" src="@/assets/img/deve_mrs.png" alt="">
                        </div>
                        <div class="deve_left2">
                            <img style="width:520px;" src="@/assets/img/deve_link.png" alt="">
                        </div>
                    </div>
                    <div class="right" style="margin-left: -207px">
                        <div class="rightTitle">开发工具</div>
                        <div class="tip" >
                            <div style="display:flex;"> <img style="margin-right:20px; width:19px; height:19px; padding-top: 7px;" src="@/assets/img/tipIcon.png" alt=""> <span style="line-height:35px">集成开发环境（IDE）：MounRiver Studio(MRS)</span> </div>
                            <div @click="clickMRSLink" style="line-height:35px; text-align:left; padding-left: 42px; cursor:pointer;">http://www.mounriver.com/</div>
                        </div>
                        <div class="tip" style="margin-top:28px;" >
                            <div style="display:flex;"> <img style="margin-right:20px; width:19px; height:19px; padding-top: 7px;" src="@/assets/img/tipIcon.png" alt=""> <span style="line-height:35px">WCH-Link仿真调试器：</span> </div>
                            <div @click="clickWCHLink" style="line-height:35px; text-align:left; padding-left: 42px; cursor:pointer;">https://www.wch.cn/products/WCH-Link.html</div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- 赛程安排 -->
            <div class="plan">
                <div class="titlePart">
                    <div class="titleText">赛程安排</div>
                    <div class="titleLine">
                        <img src="@/assets/img/titleLine.png" alt="">
                    </div>
                </div>
                <div class="planContent">
                    <div class="planItem" :class="'p_'+index" v-for="(item,index) in planArr" :key="index">
                        <div class="itemName">{{item.name}}</div>
                        <div class="itemTip">{{item.tip}}</div>
                        <div class="itemTime">{{item.time}}</div>
                    </div>
                </div>
            </div>
            <!-- 大赛评委 -->
            <div class="commitee">
                <div class="titlePart">
                    <div class="titleText">大赛评委</div>
                    <div class="titleLine">
                        <img src="@/assets/img/titleLine.png" alt="">
                    </div>
                </div>
                <div class="commiteeContent">
                    <div class="commiteeItem" v-for="(item,index) in commiteeArr" :key="index">
                        <div class="com_name">{{item.name}}</div>
                        <div class="com_position" v-for="(t,i) in item.positionArr" :key="i">
                        <div v-html="t">{{t}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 参赛须知 -->
            <div class="notice">
                <div class="titlePart">
                    <div class="titleText">参赛须知</div>
                    <div class="titleLine">
                        <img src="@/assets/img/titleLine.png" alt="">
                    </div>
                </div>
                <div class="noticeContent">
                    <div class="noticeTabs">
                        <div class="tabItem" :class="index==tabIndex?'activeTab':''" v-for="(item, index) in noticeTabArr" :key="index" @click="clickNoticeTab(index)">
                            {{item.name}}
                        </div>
                    </div>
                    <div class="tabContent">
                    <div class="content1" v-if="tabIndex==0">
                        <div v-for="(item,index) in applyArr" :key="index" >
                            <div>{{item.name}}</div>
                            <ul>
                                <li  v-for="(t,i) in item.lis" :key="i" v-html="t"></li>
                            </ul>
                        </div>
                    </div>
                    <div class="content2" v-if="tabIndex==1">
                            <div v-for="(item,index) in electArr" :key="index" style="margin:15px 0px;">
                                {{item}}
                            </div>
                            <div class="assessRules">
                                <div style="font-weight:550; line-height:36px;">作品评审规则：</div>
                                <div v-for="(item,index) in ruleArr" :key="index" class="ruleItem">
                                    {{item}}
                                </div>
                            </div>
                    </div>
                    <div class="content3" v-if="tabIndex==2">
                            <div v-for="(item,index) in rightsArr" :key="index" style="margin:15px 0px;" class="rightsItem">
                                {{item}}
                            </div>
                    </div>
                    </div>
                </div>
            </div>
            <!-- 参赛作品 -->
            <div class="work" v-show="workTotal>0">
                <div class="titlePart">
                    <div class="titleText">参赛作品</div>
                    <div class="titleLine">
                        <img src="@/assets/img/titleLine.png" alt="">
                    </div>
                </div>
                <el-row :gutter="24" class="workContent" v-loading="loading">
                    <el-col :span="6" class="workItem" v-for="(item,index) in workArr" :key="index">
                        <div class="itemC" @click="clickWorkItem(item)">
                            <div class="imgPart">
                                <img :src="imgBaseUrl+ item.icon" alt="">
                            </div>
                            <div class="textPart">
                                <div class="workTitle" >{{item.title}}</div>
                                <div class="workBy">By: {{item.contacter}}</div>
                            </div>
                        </div>
                        
                    </el-col>
                </el-row>
                <el-pagination
                    style="margin:0 auto; margin-top:25px;"
                    v-show="workTotal>0"
                    :total="workTotal"
                    :current-page.sync="currentPage"
                    :page-size="4"
                    layout="total,  prev, pager, next, jumper"
                    @current-change="getWorkArr"
                />

            </div>
            <!-- 获奖作品 -->
            <div class="prizes" v-show="prizesTotal>0">
                <div class="titlePart">
                    <div class="titleText">获奖作品</div>
                    <div class="titleLine">
                        <img src="@/assets/img/titleLine.png" alt="">
                    </div>
                </div>
                <div class="prizesContent">
                    <prizes-work ref="prizesWork" @givePrizesTotal='givePrizesTotal'></prizes-work>
                </div>
            </div>
            <!-- qq群 -->
            <div class="footer">
                <div class="title">详情可加入大赛官方QQ群交流</div>
                <div class="redline"></div>
                <div class="talkImg">
                    <img style="width: 328px;" src="@/assets/img/talkImg.png" alt="">
                </div>
                <div class="bottom">
                    <div class="left"> <span @click='gotoLaw' class="law" style="cursor:pointer">法律声明</span> | <span class="touch" style="cursor:pointer" @click="gotoTouch">联系我们</span></div>
                    <div class="right"><span class="copyRight" style="cursor:pointer" @click="gotoCopyRight">苏ICP备18001197号</span> Copyright © 2002-2021 南京沁恒微电子股份有限公司. All Rights Reserved  <img @click="gotoSite" style="margin-left:3px; cursor:pointer" src="@/assets/img/pic1.gif" alt=""></div>
                </div>
            </div>
        <!-- </div> -->
        
    </div>
   
  </div>
</template>

<script>
import phoneTest from './modules/phoneTest.vue'
import prizesWork from './modules/prizesWork.vue'
import { getAction, postAction, uploadImage } from '@/request/http'//引入封装的get post方法
import Vue from 'vue'
import { VOUCHER,MOBILE } from "@/store/mutation-types"
export default {
  name: 'matchPage',
  components: {
      phoneTest,
      prizesWork
  },
  data(){
    return{
       headerArr:[
           {name:'首页'},
           {name:'大赛奖项'},
           {name:'开发套件'},
           {name:'赛程安排'},
           {name:'参赛作品'},
           {name:'往期赛事'},
           {name:'提交作品'},
       ],
       headerIndex:'',
       sponsorArr:[
           {name:'主办方', tip:'江苏省计算机学会'},
           {name:'承办方', tip:'沁恒微电子'},
           {name:'协办方', tip:'21IC电子网、RT-Thread、腾讯TencentOS tiny、中移物联网OneOS、苏州大学金葫芦平台'},
       ],
       prizeArr:[
           {name:'一等奖', people:'1名', money:'￥10000元现金', certificate:'江苏省计算机学会证书', src:require('@/assets/img/p1.png')},// require('../../../assets/images/step_right.png')
           {name:'二等奖', people:'5名', money:'￥5000元现金', certificate:'江苏省计算机学会证书', src:require('@/assets/img/p2.png')},
           {name:'三等奖', people:'10名', money:'￥1000元现金', certificate:'江苏省计算机学会证书', src:require('@/assets/img/p3.png')},
           {name:'优秀奖', people:'25名', money:'￥200元现金', certificate:'', src:require('@/assets/img/p4.png')},
       ],
       platformArr:[
           {name:'32位互联型RISC-V MCU CH32V307', src:require('@/assets/img/platform1.png'), handbook:[
               {n:'CH32V307数据手册', link:'https://www.wch.cn/downloads/CH32V20x_30xDS0_PDF.html'},
               {n:'CH32V307参考手册', link:'https://www.wch.cn/downloads/CH32FV2x_V3xRM_PDF.html'},
               {n:'评估板说明及参考例程', link:'https://www.wch.cn/downloads/CH32V307EVT_ZIP.html'},
           ]},
           {name:'32位无线型 RISC-V MCU CH32V208', src:require('@/assets/img/platform2.png'), handbook:[
               {n:'CH32V208数据手册', link:'https://www.wch.cn/downloads/CH32V20x_30xDS0_PDF.html '},
               {n:'CH32V208参考手册', link:'https://www.wch.cn/downloads/CH32FV2x_V3xRM_PDF.html'},
               {n:'评估板说明及参考例程', link:'https://www.wch.cn/downloads/CH32V20xEVT_ZIP.html'},
           ]},
           {name:'AHL-CH32V307开发套件', src:require('@/assets/img/platform3.png'), handbook:[
               {n:'开发资料', link:'http://sumcu.suda.edu.cn/AHLwCH32V307/list.htm'},
           ]},
       ],
       planArr:[
           {name:'在线报名', tip:'评估板及芯片发放', time:'2022年10月30日'},
           {name:'提交作品', tip:'在线提交创意作品', time:'截止2022年12月31日'},
           {name:'奖项评选', tip:'评选获奖作品', time:'2023年1月1日~2023年1月10日'},
           {name:'名单公示', tip:'公布获奖名单', time:'2023年1月11日'},
       ],
       noticeTabArr:[
           {name:'报名规则'},
           {name:'评选规则'},
           {name:'相关权益'},
       ],
       tabIndex:'0',
       applyArr:[
            {name:'1. 参赛选手',lis:[
               '面向企业、创客团队、工程师、高校等人士，不限个人或团体形式参赛。',
            ]},
            {name:'2. 报名方式',lis:[
               '在线提交作品主题、基本设计思路、主要解决的问题以及创新点即可报名参赛，具体方案不限；',
               '报名信息审核通过后即安排邮寄开发板套件。',
               '报名网址：<span id="signUp" onclick="clickSignUp()" style="text-decoration:underline; cursor:pointer;"> http://risc-v-mcu.mikecrm.com/10q4nkK </span> 。'
            ]},
            {name:'3. 作品要求',lis:[
               '基于RISC-V MCU CH32V307或CH32V208进行创新应用开发，也可使用沁恒其他RISC-V架构系列MCU进行创新应用开发。',
               '或基于AHL-CH32V307等开发套件使用通用嵌入式计算机（GEC）构件进行创意开发。',
               '推荐将MCU的高速USB（480Mbps，内置PHY）、以太网、低功耗蓝牙等接口应用到作品中。',
               '推荐将参赛作品开发过程中的想法、心得分享到21ic、博客园、公众号、B站等平台，共同推进RISC-V生态建设。',
               '说明作品应用的背景、实现功能、硬件框架、软件框架，提供作品完整图片、视频演示效果。',
               '参赛者比赛项目代码须托管到Gitee或Github。',
               '应用作品必须为原创且无知识产权纠纷问题，参赛者拥有全部的知识产权。',
            ]},
       ],
       electArr:[
           '1. 所有参赛作品随机分组，各组评委随机选取一组作品评审。',
           '2. 每组评委分别查看同一组中的作品并打分，取平均值为该作品得分。',
           '3. 按作品得分从高到低排序，选取前41名作品，由所有评委再次评审打分，取平均值，根据最终得分评选大赛获得者。',
           '4. 所有参与评审的作品，需按照作品发布要求提交说明文档，否则视为不合格，不得参与评审及获奖。',
           '5.  针对计划量产项目，可申请种子资金，申请时项目负责人需单独答辩。',
       ],
       ruleArr:[
           '作品介绍（30分）：设计方案陈述逻辑清晰、视频演示到位、代码开源全面。',
           '技术贴分享（20分）：在21ic论坛、博客园、公众号、B站等平台分享设计方案的技术贴质量高、对他人有启发学习的作用。',
           '创新性（30分）：作品设计思路新颖、视角独特、有一定的实用价值。',
           '技术实用性（20分）：实现方案明确、有市场前景、具有一定的技术含量。',
       ],
       rightsArr:[
           '1. 参赛承诺：参赛者必须保证参赛作品为首次参赛的原创作品，任何参赛作品知识产权方面的争议均与本次竞赛的举办单位无关。参赛者一旦参赛即承诺其递交的参赛作品应为参赛者原创并首次参赛的作品，承诺该作品不存在权利争议或侵犯第三方知识产权的行为，违反者自行承担相应责任。',
           '2. 全部参赛作品，知识产权归参赛者所有；主办方、承办方及合作商享有对作品进行宣传、报道、展示的权利，并署名作者。',
           '3. 大赛通知：若有关于大赛的任何消息或变更事项，我们会在第一时间把变动信息公布在大赛QQ群中（群号：668096767）。',
           '4. 本次大赛获奖证书由大赛主办单位统一印制、颁发，相关奖金均为税前金额。',
           '5. 本次活动的最终解释权归主办单位所有。',
       ],
       commiteeArr:[
            {
                name:"王宜怀",
                positionArr:[
                    '苏州大学教授<br/>博士生导师',
                ]
            },
            {
                name:"李春彪",
                positionArr:[
                    '南京信息工程大学教授<br/>博士生导师',
                ]
            },
            {
                name:"张  阳",
                positionArr:[
                    '合肥工业大学副教授<br/>硕士生导师',
                ]
            },
            {
                name:"刘岩轩",
                positionArr:[
                    '21ic电子网副主编',
                ]
            },
            {
                name:"杨  勇",
                positionArr:[
                    '沁恒微电子技术总监<br/>瑞斯科研究院院长',
                ]
            },


       ],
       phoneTestShow:false,

       url:{
           workList:'/list'
       },

       workArr:[],
       currentPage:sessionStorage.getItem("currentPage")? parseInt(sessionStorage.getItem("currentPage")) : 1,
       workTotal:0,
       loading:false,
       imgBaseUrl:window._CONFIG['uploadURL'],
       prizesTotal:"",

       timer:null,
      
    }
  },
    activated(){
    },
    mounted(){
      window.clickSignUp = this.clickSignUp
      let p = sessionStorage.getItem("currentPage")
      this.currentPage = p ? parseInt(p) : 1
      this.getWorkArr()
    //   this.phoneTestShow=false

      if(this.$route.query.indexFromSubmit){
        this.clickHeaderItem(this.$route.query.indexFromSubmit)
      }

      window.addEventListener('scroll', this.getScroll)
    },
    destroyed(){
      window.removeEventListener('scroll', this.getScroll)
    },
    beforeDestroy(){
    },
    methods:{
        //点击 顶部导航栏
        clickHeaderItem(i){
            this.headerIndex=i
            console.log('this.headerIndex===',this.headerIndex)
            // 添加顶部导航栏样式
            for (let j = 0; j < document.getElementsByClassName('rightItem').length; j++) {
                document.getElementsByClassName('rightItem')[j].classList.remove('activeHeader')
            }
            document.getElementsByClassName('rightItem')[i].classList.add('activeHeader')


            // this.phoneTestShow=false
            this.getWorkArr()

            if(this.headerIndex=='0'){
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }else if(this.headerIndex=='1'){
                window.scroll({
                    top: 1180,
                    left: 0,
                    behavior: 'smooth'
                });
            }else if(this.headerIndex=='2'){
                window.scroll({
                    top: 2030,
                    left: 0,
                    behavior: 'smooth'
                });
            }else if(this.headerIndex=='3'){
                window.scroll({
                    top: 3730,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            else if(this.headerIndex=='4'){
                window.scroll({
                    top: 5400,
                    left: 0,
                    behavior: 'smooth'
                });
            }
            else if(this.headerIndex=='5'){
               window.open('https://www.wch.cn/RISC-V-MCU-competition-past/')
            }
            else if(this.headerIndex=='6'){
                
                // if(!localStorage.getItem('VOUCHER')){//不存在令牌（第一次提交）：重新输入手机号
                //    this.phoneTestShow=true
                //    this.$refs.phoneTest.init()
                // }else{//存在令牌（编辑）：直接跳转作品页
                //     this.$router.push({ path: '/submitWork', query:{sign:'2'}})
                // }

                if(!localStorage.getItem('VOUCHER')){//不存在令牌（第一次提交）：重新输入手机号
                    this.$router.push({ path: '/phoneTest'})
                }else{//存在令牌（编辑）：直接跳转作品页
                    this.$router.push({ path: '/submitWork', query:{sign:'2'}})
                }
            }

             
        },
        //监听页面滚动
        getScroll(){
            if(this.headerIndex!='6'){
                clearTimeout(this.timer);  //滚动时清除定时器
                this.timer = null
                this.timer = setTimeout(function(){
                    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;//保证兼容性
                    if(scrollTop>=0 && scrollTop<350){
                        this.headerIndex = '0'
                        console.log(0)
                    }else if(scrollTop>=350 && scrollTop<1300){
                        this.headerIndex = '1'
                        console.log(1)
                    }else if(scrollTop>=1300 && scrollTop<3100){
                        this.headerIndex = '2'
                        console.log(2)
                    }else if(scrollTop>=3100 && scrollTop<3900){
                        console.log(3)
                        this.headerIndex = '3'
                    }else if(scrollTop>=4700 ){
                        this.headerIndex = '4'
                        console.log(4)
                    }
                    // 添加顶部导航栏样式
                    for (let i = 0; i < document.getElementsByClassName('rightItem').length; i++) {
                        document.getElementsByClassName('rightItem')[i].classList.remove('activeHeader')
                    }
                    document.getElementsByClassName('rightItem')[this.headerIndex].classList.add('activeHeader')
                },100)  //当停止滚动时定时器执行
            }
              


            // window.onscroll = function() {
            // //scrollTop就是触发滚轮事件时滚轮的高度
            //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;//保证兼容性
            //     if(scrollTop>=0 && scrollTop<350){
            //         this.headerIndex = '0'
            //         console.log(0)
            //     }else if(scrollTop>=350 && scrollTop<1300){
            //         this.headerIndex = '1'
            //         console.log(1)
            //     }else if(scrollTop>=1300 && scrollTop<3100){
            //         this.headerIndex = '2'
            //         console.log(2)
            //     }else if(scrollTop>=3100 && scrollTop<3900){
            //         console.log(3)
            //         this.headerIndex = '3'
            //     }else if(scrollTop>=4700 ){
            //         this.headerIndex = '4'
            //         console.log(4)
            //     }
            //     // 添加顶部导航栏样式
            //     for (let i = 0; i < document.getElementsByClassName('rightItem').length; i++) {
            //         document.getElementsByClassName('rightItem')[i].classList.remove('activeHeader')
            //     }
            //     document.getElementsByClassName('rightItem')[this.headerIndex].classList.add('activeHeader')
            // }
        },


       //点击左上角logo
        clickLogoImg(){
            window.open('https://www.wch.cn')
        },
        clickLink(link){
            window.open(link)
        },
        clickMRSLink(){
            window.open('http://www.mounriver.com/')
        },
        clickWCHLink(){
            window.open('https://www.wch.cn/products/WCH-Link.html')
        },
         //点击法律声明
        gotoLaw(){
            window.location.href='http://www.wch.cn/statement.html'
        },
        //点击联系我们
        gotoTouch(){
            window.location.href='http://www.wch.cn/contact_us.html'
        },
        //点击CopyRight
        gotoCopyRight(){
            window.location.href='https://beian.miit.gov.cn/#/Integrated/index'
        },
        //点击底部的gif图
        gotoSite(){
            window.location.href='https://uweb.umeng.com/v1/login.php?siteid=1254526631'
        },


        //点击 参赛须知tab
        clickNoticeTab(i){
            this.tabIndex=i
        },
        //点击报名网址
        clickSignUp(){
            window.open('http://risc-v-mcu.mikecrm.com/10q4nkK')
        },

        //获取参赛作品
        getWorkArr(){
           sessionStorage.setItem("currentPage", this.currentPage.toString());
           var params = {
               pageNum: this.currentPage,
               pageSize:4,
               isShow:'1',
               statusArr:"WAIT_RATING,WAIT_PRIZE,COMPLETE",//等待评分 、等待评奖、完成
           }
            this.loading = true;
            getAction(this.url.workList, params)
                .then(res => {
                if(res.data.code==200){
                    this.workArr = res.data.rows;
                    this.workTotal = res.data.total;
                }else{
                    this.msgError(res.data.msg);
                }
                this.loading = false;
                }
            );

        },
        givePrizesTotal(value){
            console.log('value----',value)
            this.prizesTotal = value

        },

        //参赛作品详情
        clickWorkItem(item){
            this.$router.push({ path: '/workDetail', query:{view:'2', workId:item.id}})
        }
        
    },
}
</script>

<style scoped > 
/* html{
    font-size: 100px;
} */
.phoneTestContainer{
    width: 100%;
    padding-top: 60px;
}

.matchPage{
    width: 1903px;
    /* width: 100%; */
    background: #fff;
}
/* header */
.header{
    width: 80%;
    height: 80px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.header .left{
    font-size: 28px;
    font-weight: 600;
    line-height: 80px;
}
.header .right{
    display: flex;
}
.header .right .rightItem{
    font-size: 20px;
    line-height: 80px;
    margin: 0px 15px;
    width: 100px;
    text-align: center;
    color: #000;
    font-weight: 550;
    cursor: pointer;
}
.header .right .activeHeader{
    color: #008cff;
    border-bottom: 5px solid #008cff;
}
/* banner */
.banner{
    width: 100%;
    height: 420px;
    margin-top: 80px;
}
.banner img{
    width: 100%;
}
/* brief */
.brief{
    padding: 80px 0px;
    background: #fbfbfb;
    background: url('@/assets/img/briefBg.png') no-repeat;
    background-size: cover;
}
.titlePart{
    width: 248px;
    margin: 0 auto;
}
.titleText{
    font-size: 40px;
    font-weight: 550;
    line-height: 80px;
    color: #000;
    text-align: center;
}
.briefContent{
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
}
.briefContent .left{
    text-align: left;
    color: #000;
    font-size: 20px;
    line-height: 34px;
    letter-spacing:2px;
}
.briefContent .left .firstPart0{
    text-indent:2em;
}
.briefContent .left .firstPart1{
    text-indent:2em;
}
.briefContent .left .firstPart2{
    text-indent:2em;
    margin-bottom: 50px;
}
.briefContent .left .secondPart .sponsor{
    display: flex;
    margin: 10px 0px;
}
.briefContent .left .secondPart .sponsor .sponsorName{
    background: url('@/assets/img/sponsor.png') no-repeat;
    width: 104px;
    height: 27px;
    text-align: center;
    color: #fff;
    line-height: 27px;
    margin-right: 20px;
}
.briefContent .right{
    margin-left: 20px;
}
/* prize */
.prize{
    width: 75%;
    margin: 0 auto;
}
.prizeContent{
   margin-top: 40px;
   display: flex;
   justify-content: space-between;
}
.prizeItem{
    width: 260px;
    height: 333px;
    box-shadow:  0 0px 10px rgba(129, 197, 255, .5);
    padding: 30px;
    box-sizing: border-box;
    line-height: 34px;
    font-weight: 550;
}
.prizeItem .name{
    font-size: 24px;
    color: #000;
}
.prizeItem .people{
    font-size: 24px;
    color: #29b6f3;
}
.prizeItem .money{
    font-size: 20px;
    color: #1a66cb;
}
.prizeItem .certificate{
    font-size: 20px;
    color: #000;
}
.prizeItem2{
    width: 720px;
    /* height: 333px; */
    margin: 0 auto;
    box-shadow:  0 0px 10px rgba(129, 197, 255, .5);
    padding: 30px;
    box-sizing: border-box;
    line-height: 34px;
    display: flex;
    justify-content: space-around;
    padding: 25px;
    margin-top: 40px;
}
.prizeItem2 .right {
    line-height: 50px;
    font-weight: 550;
}
.prizeItem2 .right .name{
    font-size: 24px;
    color: #000;
}
.prizeItem2 .right .people{
    font-size: 24px;
    color: #29b6f3;
}
.prizeItem2 .right .money{
    font-size: 36px;
    color: #1a66cb;
}
.prizeItem2 .right .certificate{
    font-size: 18px;
    color: #000;
}

.prizeTips{
    font-size: 18px;
    margin-top: 30px;
    color: #a9a9a9;
}
/* platform */
.platform{
    width: 100%;
    height: 1731px;
    background: url('@/assets/img/platformBg3.png') no-repeat;
    background-color: #f7fbff;
    background-size: 100%;
    margin-top: 50px;
}
.platformTitle{
    margin: 0 auto;
    text-align: center;
    padding-top: 60px;
}
.platformTitle .titleText{
    color: #fff;
    font-size: 40px;
    font-weight: 550;
    letter-spacing: 5px;
}
.platformContent{
    margin-top: 40px;
}
.platformContent .platformItem{
    display: flex;
    width: 1110px;
    height: 320px;
    /* margin: 0 auto; */
    margin-left: 28%;
    border: 3px solid #fff;
    border-radius: 2px;
    margin-bottom: 40px;
}
.platformItem .left{
    width: 520px;
    height: 280px;
    background: #fff;
    border-radius: 15px;
    margin-top: 18px;
    margin-left: -24%;
}
.platformItem .deve_left1{
    width: 520px;
    height: 120px;
    background: #fff;
    border-radius: 15px;
    margin-top: 20px;
    margin-left: -51%;
}
.platformItem .deve_left2{
    width: 520px;
    height: 120px;
    background: #fff;
    border-radius: 15px;
    margin-top: 34px;
    margin-left: -51%;
}
.platformItem .right{
    padding: 20px;
    margin-left: 60px;
}
.platformItem .rightTitle{
    font-size: 24px;
    color: #fff;
    font-weight: 550;
    line-height: 40px;
}
.platformItem .right .tip{
    font-size: 20px;
    color: #fff;
    margin: 5px 0px;
}
.platformItem .platformImg_0{
    margin-top: 5px;
}
.platformItem .platformImg_1{
    margin-top: 20px;
}
.platformItem .platformImg_2{
    margin-top: 20px;
}
/* plan */
.plan{
    width: 100%;
    background: url('@/assets/img/plancBg.png') no-repeat;
    padding-top: 40px;
    height: 495px;
    box-sizing: border-box;
}
.planContent{
    /* background: url('@/assets/img/plancBg.png') no-repeat; */
    display: flex;
    justify-content: space-between;
    width: 75%;
    margin: 0 auto;
    margin-top: 130px
}
.p_1{
    margin-left: 73px;
}
.planItem .itemName{
    font-size: 30px;
    color: #000;
    font-weight: 550;
    line-height: 45px;
}
.planItem .itemTip{
    font-size: 18px;
    color: #333;
    line-height: 30px;
}
.planItem .itemTime{
    font-size: 18px;
    color: #333;
    line-height: 30px;
}
/* commitee */
.commitee{
    margin-top: 50px;
    width: 100%;
}
.commitee .commiteeContent{
    width: 75%;
    margin: 0 auto;
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
}
.commiteeItem{
    width: 180px;

}
.com_name{
    width: 110px;
    height: 54px;
    background: url('@/assets/img/commiteeBg.png') no-repeat;
    background-size: 110px;
    color: #fff;
    font-size: 20px;
    line-height: 46px;
    margin: 0 auto;
}
.com_position{
    margin-top: 15px;
    line-height: 24px;
    color: #8199d1;
}
/* notice */
.notice{
    margin-top: 50px;
    margin-bottom: 60px;
}
.noticeContent{
    width: 74%;
    margin: 0 auto;
}
.noticeTabs{
    height: 64px;
    width: 100%;
    background: #f7fbff;
    display: flex;
    border-bottom: 2px solid #b0dcf1ba;
    padding-left: 50px;
    box-sizing: border-box;
}
.tabItem{
    width: 150px;
    font-size: 24px;
    line-height: 64px;
    color: #000;
    font-weight: 550;
    margin: 0 25px;
    cursor: pointer;
}
.activeTab{
    color: #008cff;
    border-bottom: 5px solid #008cff;
}
.tabContent{
    margin-top: 20px;
    background: url('@/assets/img/noticeBg.png') no-repeat;
    /* height: 554px; */
    height: 580px;
    background-size: cover;
    text-align: left;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 3px;
    color: #fff;
    padding: 32px 30px;
    box-sizing: border-box;
}
.assessRules{
    margin-top: 30px;
}
.assessRules .ruleItem{
    margin: 5px 0px;
    line-height: 36px;
}
.rightsItem{
    margin: 5px 0px;
    line-height: 36px;
}
/* footer */
.footer{
    background: url('@/assets/img/footerImg.png') no-repeat;
    height: 860px;
    width: 100%;
    margin-top: 50px;
}
.footer .title{
    font-size: 38px;
    color: #fff;
    font-weight: 700;
    text-align: center;
    padding-top: 200px;
    letter-spacing:5px;
}
.footer .redline{
    width: 46px;
    height: 2px;
    background: #e64569;
    margin-left: 49%;
    margin-top: 20px;
}
.footer .talkImg{
    margin-top: 40px;
}
/* 参赛作品 */
.work{
    width: 74%;
    margin: 0 auto;
}
.workContent{
    display: flex;
    width: 100%;
    margin-top: 20px;
}
.workItem{
    padding: 0px;
}
.imgPart img{
    width: 100%;
    height: 200px;
    border-radius: 8px 8px 0px 0px;
}
.workItem .textPart{
    text-align: left;
    font-size: 15px;
    line-height: 28px;
    padding: 0 10px;
    color: #fff;
}
.workTitle{
    font-size: 18px;
    white-space:nowrap;
    text-overflow: ellipsis;
    overflow:hidden;
}
.workBy{
    white-space:nowrap;
    text-overflow: ellipsis;
    overflow:hidden;
}
.itemC{
    width: 90%;
    margin: 0 auto;
    background: #61c5ff;
    /* border: 1px solid #e3e3e3; */
    border-radius: 1%;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 20%);
}
/* 获奖作品 */
.prizes{
  width: 74%;
  margin: 0 auto;
  margin-top: 60px;
}
.prizesContent{
    margin-top: 30px;
}

.footer .bottom{
    width: 74%;
    margin: 0 auto;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    height: 20px;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
  }
   .footer .bottom .right{
    display: flex;
    justify-content: space-between;
  }
</style>
